<template>
  <!--    <BasicLayout>-->
  <el-container style="padding: 0px">
    <el-aside width="240px">
      <!--                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==1}" @click.native="region"><span :class="{ico1:true,ico1A:active===1}"></span><span>组织架构</span></el-row>-->
      <!--                <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==1}" @click.native="region"><span :class="{ico1:true,ico1A:active===1}"></span><span>组织架构</span></el-row>-->
      <el-row type="flex" justify="start" align="middle" class="topTab" @click.native=""><span>日程安排</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 1 }" @click.native="calendar1"><span>日程表</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==2}" @click.native="calendar2"><span>周计划</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 13 }" @click.native="calendar13"><span>计划小结</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 3 }" @click.native="calendar3"><span>差旅计划</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 4 }" @click.native="calendar4"><span>公司会议/培训</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 5 }" @click.native="calendar5"><span>公司内部工作</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 6 }" @click.native="calendar6"><span>请假/休假</span></el-row>
      <el-row type="flex" justify="start" align="middle" class="topTab" @click.native=""><span>辖区事务</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 7 }" v-if="clientObj.showInstitution" @click.native="calendar7"
        ><span>医务拜访</span></el-row
      >
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 12 }" v-if="clientObj.showStore" @click.native="calendar12"
        ><span>门店巡查</span></el-row
      >
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 8 }" v-if="clientObj.showDistributor" @click.native="calendar8"
        ><span>商务拜访</span></el-row
      >
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 9 }" @click.native="calendar9"><span>会议/活动</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 10 }" @click.native="calendar10"><span>辅导/协访</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 11 }" @click.native="calendar11"><span>辖区签到</span></el-row>
      <el-row type="flex" justify="start" align="middle" :class="{ options: true, optionsActive: active == 14 }" @click.native="calendar14"><span>线上会议</span></el-row>
      <!--            <el-row type="flex" justify="start" align="middle" :class="{options:true,optionsActive:active==11}"-->
      <!--                    @click.native="calendar11"><span>辖区签到</span></el-row>-->
    </el-aside>
    <el-main>
      <keep-alive :include="includePageNames">
        <!-- includePageNames是数组，用来存放需要缓存的页面的路由中的path或者name的 -->
        <router-view></router-view>
      </keep-alive>
    </el-main>
  </el-container>
  <!--    </BasicLayout>-->
</template>

<script>
import axios from "axios";
import http from "../../APIService/http";
// import BasicLayout from "../../components/navHeader";
import { bus } from "../../router/index";

export default {
  name: "index",
  components: {
    // BasicLayout
  },
  data() {
    return {
      active: 1,
      options: [],
      includePageNames: [],
      clientObj: {},
    };
  },
  created() {
    this.clientObj = this.$store.getters.getClient;
    // console.log(this.$store.getters.getClient,111)
    this.active = localStorage.getItem("active");
  },
  mounted() {
    // this.getManager()
  },
  watch: {
    $route(to, from) {
      if (to.name === "travel" || to.name === "jurisdictionInfo") {
        this.includePageNames.push("travel");
      } else {
        this.includePageNames = [];
      }
    },
  },
  methods: {
    calendar1() {
      this.$router.push({
        path: "/calendar/calendarTable",
      });
      localStorage.setItem("active", 1);
      this.active = localStorage.getItem("active");
    },
    calendar2() {
      this.$router.push({
        path: "/calendar/weekPlan",
      });
      localStorage.setItem("active", 2);
      this.active = localStorage.getItem("active");
    },
    calendar13() {
      this.$router.push({
        path: "/calendar/planSummary",
      });
      localStorage.setItem("active", 13);
      this.active = localStorage.getItem("active");
    },
    calendar3() {
      this.$router.push({
        path: "/calendar/evection",
      });
      localStorage.setItem("active", 3);
      this.active = localStorage.getItem("active");
    },
    calendar4() {
      this.$router.push({
        path: "/calendar/cultivate",
      });
      localStorage.setItem("active", 4);
      this.active = localStorage.getItem("active");
    },
    calendar5() {
      this.$router.push({
        path: "/calendar/firmJob",
      });
      localStorage.setItem("active", 5);
      this.active = localStorage.getItem("active");
    },
    calendar6() {
      this.$router.push({
        path: "/calendar/vacation",
      });
      localStorage.setItem("active", 6);
      this.active = localStorage.getItem("active");
    },
    calendar7() {
      this.$router.push({
        path: "/calendar/medical",
      });
      localStorage.setItem("active", 7);
      this.active = localStorage.getItem("active");
    },
    calendar8() {
      this.$router.push({
        path: "/calendar/business",
      });

      localStorage.setItem("active", 8);
      this.active = localStorage.getItem("active");
    },
    calendar9() {
      this.$router.push({
        path: "/calendar/conference",
      });
      localStorage.setItem("active", 9);
      this.active = localStorage.getItem("active");
    },
    calendar10() {
      this.$router.push({
        path: "/calendar/tutoring",
      });
      localStorage.setItem("active", 10);
      this.active = localStorage.getItem("active");
    },
    calendar11() {
      this.$router.push({
        path: "/calendar/jurisdictionIn",
      });
      localStorage.setItem("active", 11);
      this.active = localStorage.getItem("active");
    },
    calendar12() {
      this.$router.push({
        path: "/calendar/storeTour",
      });
      localStorage.setItem("active", 12);
      this.active = localStorage.getItem("active");
    },
    calendar14() {
      this.$router.push({
        path: "/calendar/onlineMeeting",
      });
      localStorage.setItem("active", 14);
      this.active = localStorage.getItem("active");
    },
    // async getManager(){
    //     try {
    //
    //         let data={
    //             user_id : this.$store.getters.getUser.user_id,
    //             tenant_id : this.$store.getters.getUser.tenant_id,
    //             isHead : 'F'
    //         }
    //         await http.post('/wapi/JurisdictionIn/getOrganizationPersonnelList',data).then(res=>{
    //             console.log(res)
    //             this.options = res.data
    //             // let obj={
    //             //     user_id : '',
    //             //     user_name:'所有下属'
    //             // }
    //             // this.options.unshift(obj)
    //         })
    //         this.GLOBAL.options_global = this.options
    //         console.log(this.GLOBAL.options_global)
    //     } catch (e) {
    //
    //     }
    // },
  },
  beforeRouteLeave(to, from, next) {
    localStorage.setItem("active", 1);

    next();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === "calendarTable") {
      this.active = 1;
    }
    next();
  },
};
</script>

<style scoped>
.topTab {
  font-size: 18px;
  height: 60px;
  padding-left: 40px;
  color: #bbbbbb;
}
.el-aside {
  background: #f4f6f8;
  padding: 15px 0;
  /*border: 1px solid #DCDFE6;*/
}
.el-main {
  background: white;
  /*border: 1px solid #DCDFE6;*/
  border-left: none;
  padding: 34px 20px 10px;
}
.options {
  cursor: pointer;
  height: 45px;
  font-family: "Hiragino Sans GB";
  font-size: 16px;
  color: #323232;
  padding-left: 70px;
  user-select: none;
}

.ico1:before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  background: url("../../assets/images/Fill2.png") no-repeat center;
  margin-right: 20px;
  background-size: cover;
}
.ico2:before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  text-align: center;
  background: url("../../assets/images/ico1.png") no-repeat center;
  margin-right: 20px;
  background-size: contain;
}
.ico3:before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  text-align: center;
  background: url("../../assets/images/diction1.png") no-repeat center;
  margin-right: 20px;
  background-size: contain;
}
.ico4:before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  text-align: center;
  background: url("../../assets/images/dataBank2.png") no-repeat center;
  margin-right: 20px;
  background-size: contain;
}
.ico5:before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  text-align: center;
  background: url("../../assets/images/systemParameter1.png") no-repeat center;
  margin-right: 20px;
  background-size: contain;
}
.ico6:before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  text-align: center;
  background: url("../../assets/images/productSku1.png") no-repeat center;
  margin-right: 20px;
  background-size: contain;
}
/* .options:hover{
         color: white;
         background: #409EFF;
     }
     .options:hover .ico1:before{
         background: url("../../assets/images/Fill1.png") no-repeat center;
     }
     .options:hover .ico2:before{
         background: url("../../assets/images/ico2.png") no-repeat center;
     }*/
.optionsActive {
  cursor: pointer;
  height: 45px;
  font-family: Hiragino Sans GB;
  font-size: 16px;
  color: #323232;
  padding-left: 70px;
  user-select: none;
  color: #3998f7;
  font-weight: bold;
}
.ico1A:before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  text-align: center;
  margin-right: 20px;
  background: url("../../assets/images/Fill1.png") no-repeat center;
  background-size: contain;
}
.ico2A:before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  text-align: center;
  margin-right: 20px;
  background: url("../../assets/images/ico2.png") no-repeat center;
  background-size: contain;
}
.ico3A:before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  text-align: center;
  margin-right: 20px;
  background: url("../../assets/images/diction2.png") no-repeat center;
  background-size: contain;
}
.ico4A:before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  text-align: center;
  margin-right: 20px;
  background: url("../../assets/images/dataBank1.png") no-repeat center;
  background-size: contain;
}
.ico5A:before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  text-align: center;
  margin-right: 20px;
  background: url("../../assets/images/systemParameter2.png") no-repeat center;
  background-size: contain;
}
.ico6A:before {
  content: "";
  display: inline-block;
  width: 22px;
  height: 22px;
  text-align: center;
  margin-right: 20px;
  background: url("../../assets/images/productSku2.png") no-repeat center;
  background-size: contain;
}
.el-container {
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/calendar/index.vue